import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ModelService} from '../services/model.service';
import {SafeResourceUrl} from '@angular/platform-browser';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Component({
    selector: 'app-elvis',
    templateUrl: './elvis.component.html',
    styleUrls: ['./elvis.component.scss']
})
export class ElvisComponent implements AfterViewInit {
    @ViewChild('autoForm') autoForm: ElementRef;
    elvisUrl: string;
    parameterList;
    formData: string;

    constructor(protected modelService: ModelService, private httpClient : HttpClient) {
        [this.elvisUrl,this.parameterList] = this.splitElvisUrl(modelService.elvisUrl);
        this.formData = ""

        this.parameterList.forEach(parameter=>this.formData+= '"'+parameter.key+'"="'+parameter.value+'",')
        this.formData = '{' + this.formData + '}'
        console.log('constructor', this.elvisUrl, this.parameterList, this.formData);
    }

    ngAfterViewInit(): void {
        this.autoForm.nativeElement.submit();
    }

    private splitElvisUrl(fullUrl: SafeResourceUrl) {
        let urlParts = fullUrl['changingThisBreaksApplicationSecurity'].split('?');
        let [url, params] = urlParts;
        let paramerList = [];

        params.split('&').map(p => {
            let [key, value] = p.split('=');
            console.log('decodeURIComponent', value);
            value = decodeURIComponent(value);
            console.log('decodeURIComponent', value);
            paramerList.push({key,value});
        });
        return [url, paramerList];
    }
}
